import { render, staticRenderFns } from "./BoardViewArchive.vue?vue&type=template&id=b66dd31e"
import script from "./BoardViewArchive.vue?vue&type=script&lang=js"
export * from "./BoardViewArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports